module.exports = __webpack_public_path__ + "static/media/basket.916c2805.jpg";